import {
    React,Component,BootstrapTable,
    paginationFactory,Button, ButtonToolbar, Card, 
    Form, Col, Row, axios, Container, Banner, Typeahead, TimePicker,
    cellEditFactory, Type, moment, NavLink, Alert, AppConfiguration,
    NoserLoading, Noser, sizePerPageRenderer, DatePicker, Modal
} 
from '../../../noser-hris-component';

class CreateDepartmentSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userinfo    :   JSON.parse(sessionStorage.getItem("userData")),
            isloading   :   false,
            isshow      :   false,
            alerttype   :   "",
            message     :   "",
            color       :   "",
            fade        :   true,
            code        :   '',
            name        :   '',
            departmentCodeAutocomplete : [],
            department  : "",
            IsBackendDDL   :      [{"id"    : "0","name" : "FRONTEND",}, {"id"   : "1","name" : "BACKEND",}, ],
            isBackend   : "",
            costCenter  : "",
            departmentID  : "",
            
        

        }
    }
    

    componentDidMount(){
        const sleep = (milliseconds) => {return new Promise(resolve => setTimeout(resolve, milliseconds))}
        this.state.userinfo = JSON.parse(sessionStorage.getItem("userData"))
        this.GetDepartment();
        this.props.onRefModal(this)        
    }
    
    componentWillUnmount() {
        this.props.onRefModal(undefined)
    }
    initialize=(e)=>{
        this.setState({
            userinfo    :   JSON.parse(sessionStorage.getItem("userData")),
            isloading   :   false,
            isshow      :   false,
            alerttype   :   "",
            message     :   "",
            color       :   "",
            fade        :   true,
            code        :   '',
            name        :   '',
            disableBtn  :   true,
            departmentCodeAutocomplete : [],

            getSection  : [],
            department  : "",
            IsBackendDDL   :      [{"id"    : "0","name" : "FRONTEND",}, {"id"   : "1","name" : "BACKEND",}, ],
            isBackend   : "",   
            costCenter  : "",
            departmentID  : "",


        })
        this.GetDepartment();
        this.GetSection();


    }

    GetSection() {
        const areaCodeParams = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId,
           // "Code"          :   "",
            "Name"          :   "",
            
        };

        axios.post(AppConfiguration.Setting().noserapiendpoint + "Maintenance/GetSections",  areaCodeParams)
        .then(res => {
            const data = res.data;
            //console.log("Get section modal #2");
            //console.log(data);
            this.setState({
                getSection    :   data.sections
            });
         })
    }

    GetDepartment() {
        const departmentCodeParams = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId,
            "Code"          :   "",
            "Name"          :   "",
            "CostCenterId"  :   "",
        };

        axios.post(AppConfiguration.Setting().noserapiendpoint + "Maintenance/GetDepartments",  departmentCodeParams)
        .then(res => {
            const data = res.data;
            //console.log("Get Departments Code");
            //console.log(data);
            this.setState({
                departmentCodeAutocomplete  :   data.departments
            });
        })
    }

    handleEventDepartment = (e) => {
        //console.log(e)
            if (e.length > 0) {
            this.state.selectedDepartment = e[0].name
            this.state.selectedDepartmentId = e[0].id
        } else {
            this.state.selectedDepartment = ""
            this.state.selectedDepartmentId = ""
        }
        this.GetCostCenter();
    }

    handleEventCostCenter = (e) => {
        //console.log(e)
            if (e.length > 0) {
            this.state.selectedCostCenter = e[0].name
            this.state.selectedCostCenterId = e[0].id
        } else {
            this.state.selectedCostCenter = ""
            this.state.selectedCostCenterId = ""
        }
        //console.log(this.state.selectedCostCenterId )
    }



    GetCostCenter() {
        const costParams = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId,
            "AreaId"        :   this.state.selectedAreaId,
            "Code"          :   this.state.code,
            "Name"          :   this.state.description
        };

        axios.post(AppConfiguration.Setting().noserapiendpoint + "Maintenance/GetCostCenters",  costParams)
        .then(res => {
            const data = res.data;
            //console.log("Get Cost center");
            //console.log(data);
            this.setState({
                costCenterListDDL  :   data.costCenters,
                isloading       :   false,
            })
        })
    }


    handleSaveClick = event => {
        //this.setState({isloading:true})

        const areaParams = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId,
            "Code"          :   this.state.code,
            "Name"          :   this.state.section,
            "DepartmentId"  :   this.state.selectedDepartmentId

        };

        //console.log("Submit Params")
        //console.log(areaParams)

        axios
            .post(
                AppConfiguration.Setting().noserapiendpoint + "Maintenance/AddSection",  areaParams
            )
            .then(res => {
                const data = res.data;
                //console.log(data)
                if(data.status=="1"){
                this.setState({
                        isloading   :   false,
                        alerttype   :   "Success!",
                        isshow      :   true,
                        color       :   "success",
                        message     :   data.message,
                        fade        :   true
                    });
                    //console.log("params = 1")
                
                }
                else {
                    this.setState({
                        isloading   :   false,
                        alerttype   :   "Error!",
                        isshow      :   true,
                        color       :   "danger",
                        message     :   data.message,
                        fade        :   true
                    });
                    //console.log("params = 0")
                }
                //console.log(res)
            })
            //console.log("end params")
    }

    
    handleModalClose = () => {
        this.props.onHide();            
    }

    handleChangeName = (e) =>{
        this.setState({[e.target.name]: e.target.value})
    }


    handleChangeCostcenter = (e) =>{
        this.setState({costCenter: e.target.value})
    }

    handleChangeDepartment = (e) =>{
        if(e.length==0)
        {
            this.state.department= ''
            return
        }
        this.state.department= e[0].name
        this.state.departmentID= e[0].id
        //console.log(this.state.departmentID)
    }

    handleChangeisBackend = (e) =>{
        if(e.length==0)
        {
            this.state.isBackend= ''
            return
        }
        this.state.isBackend= e[0].id
    }

    handleSubmit = (e) =>{
        this.setState({isloading:true})

       /* if(this.state.department==""){
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "Please select department.",
                fade        :   true
            })
            return 
        }

        if(this.state.name==""){
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "Please enter section name.",
                fade        :   true
            })
            return 
        }

        if(this.state.costCenter==""){
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "Please please enter cost center.",
                fade        :   true
            })
            return 
        }

        if(this.state.isBackend==""){
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "Please please enter cost center.",
                fade        :   true
            })
            return 
        }*/

        const param = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId,
            "Name"          :   this.state.name,
            "Code"    :   this.state.code,
            "DepartmentId"  :   this.state.departmentID
            
        }
        console.log("param dahsdagdsjajsd")
        console.log(param)
        //console.log("param")
        axios
        .post(
            AppConfiguration.Setting().noserapiendpoint + "Maintenance/AddSection",  param
        )
        .then(res => {
            const data = res.data;
            //console.log(" CREATE SECTION MODAL submited")
            //console.log(data)
            this.setState({
                isloading   :   false,
                alerttype   :   res.data.status=="1" ? "Success!" : "!Error",
                isshow      :   true,
                color       :   res.data.status=="1" ? "success" : "danger",
                message     :   data.message,
                fade        :   true
            });
            this.GetSection()

        })
        .catch(error=>{
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade        :   true
            })
        })
    }

    render() { 
        return ( 

            <Modal
                {...this.props}
                return
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        CREATE SECTION
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Alert isOpen={this.state.isshow} color={this.state.color} fade={this.state.fade} className={this.state.isshow ? 'display-block' : 'display-none'}>
                            <div className={this.state.color}></div> 
                            {this.state.message}
                        </Alert>
                        <Form.Row>
                            <Form.Group as={Col} sm={12} >
                                <Typeahead
                                    ref="clearRef1"
                                    labelKey='name'
                                    id="basic-example"
                                    onChange={this.handleChangeDepartment}
                                    options={this.state.departmentCodeAutocomplete}
                                    placeholder="Select Department"
                                />
                            </Form.Group>
                        </Form.Row>
                        <Row>
                            <Form.Group as={Col} sm={12} >
                                <Form.Control 
                                     type="text"
                                     id="code"
                                     name="code"
                                     value={this.state.code}
                                     autoComplete="off"
                                     placeholder='Enter Section Code'
                                     onChange={this.handleChangeName}
                                     maxLength="10"
                                
                                    
                                />
                            </Form.Group>
                        </Row>
                        <Row>
                            <Form.Group as={Col} sm={12} >
                                <Form.Control 
                                    name='name'
                                    type="text" 
                                    placeholder="Enter section name" 
                                    onChange={this.handleChangeName} 
                                    autoComplete="off" 
                                    value={this.state.name}
                                    
                                />
                            </Form.Group>
                        </Row>
                        {/* <Form.Row>
                            <Form.Group as={Col} sm={12} >
                                <Typeahead
                                    ref="clearRef1"
                                    labelKey='name'
                                    id="basic-example"
                                    onChange={this.handleChangeisBackend}
                                    options={this.state.IsBackendDDL}
                                    placeholder="Select type"
                                />
                            </Form.Group>
                        </Form.Row> */}
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <ButtonToolbar >
                        <Button variant="success" style={{minWidth:'60px',marginRight:'1pt'}} className="ml-auto" onClick = { this.handleSubmit }>Save</Button>&nbsp;&nbsp;
                        <Button variant="danger" style={{minWidth:'60px',marginRight:'15px'}} onClick={this.props.onHide}>Close</Button>
                    </ButtonToolbar>
                </Modal.Footer>
                <NoserLoading show={this.state.isloading} />
        </Modal>
        );
    }
}

export default CreateDepartmentSection;
